import React from "react"
import classNames from "classnames"
import { Divider, Link } from "@mui/material"
import { Toolbar } from "@mui/x-data-grid-premium"

export interface DashboardToolbarProps {
  baseToolbarButtons: React.ReactNode
  rightToolbarButtons?: React.ReactNode
  explainSteps?: string
  onExplainToggle: () => void
  isExplainOpen: boolean
  [key: string]: unknown
}

export default function DashboardToolbar({
  baseToolbarButtons,
  rightToolbarButtons,
  explainSteps,
  onExplainToggle,
  isExplainOpen,
  ...toolbarProps
}: DashboardToolbarProps) {
  return (
    <Toolbar className="component_dashboard-table-artifact__toolbar" {...toolbarProps}>
      {explainSteps && (
        <>
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={onExplainToggle}
            className={classNames("component_dashboard-table-artifact__explain-link", {
              "component_dashboard-table-artifact__explain-link--active": isExplainOpen,
            })}
          >
            How was this generated ?
          </Link>
          <Divider orientation="vertical" className="component_dashboard-table-artifact__toolbar-divider" />
        </>
      )}

      {baseToolbarButtons}

      {rightToolbarButtons && (
        <>
          <Divider orientation="vertical" className="component_dashboard-table-artifact__toolbar-divider" />
          {rightToolbarButtons}
        </>
      )}
    </Toolbar>
  )
}
